export enum CostType {
  TeachingHours = "Undervisningstimer",
  OtherHours = "Andre timer",
  OtherExpenses = "Andre utgifter",
}
